import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const registerNewLoyaltyStyle = () => ({
	registerNewLoyaltyWrapper: {
		width: '100%',
	},
	buttonsWrapper: {
		width: '100%',
		background: whiteColor,
		display: 'flex',
		justifyContent: 'flex-end',
		padding: 32,
	},
	headingWrapper: {
		paddingBottom: '24px',
	},
	descriptionWrapper: {
		paddingTop: '30px',
		paddingBottom: '12px',
	},
	numbersWrapper: {
		display: 'flex',
		paddingTop: '12px',
		paddingBottom: '24px',
		justifyContent: 'center',
		alignItems: 'center',
	},
	noteWrapper: {
		marginBottom: '16px',
	},
});

export default registerNewLoyaltyStyle;
